import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import 'dayjs/locale/en';
import 'dayjs/locale/ro';
import 'dayjs/locale/hu';

import { ConsoleLogger, LogLevel, Logger, initialize } from 'in-time-logger';
import { isDevelopmentProject } from './core/utils/firebase-utils';
import { TimeZone } from 'in-time-core';
import { initializeSerialization } from './app.serialization';
import { createBrowserDatabaseIdGenerator } from './core/utils/crypto-utils';

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);

export function initializeDependencies(): void {
  const loggers: Logger[] = [
    new ConsoleLogger(isDevelopmentProject() ? LogLevel.Debug : LogLevel.Warning, 'in-time-admin')
  ];

  initialize(loggers);

  TimeZone.ensureInitialized();
  initializeSerialization({
    databaseIdGenerator: createBrowserDatabaseIdGenerator(),
  });
}
